import { Box, Hidden } from '@material-ui/core';
import { MyLinksLayout } from '../MyLinks.styles';
import { MainProfileProps } from '../types';
import { FC, Fragment } from 'react';
import LearnMore from './LearnMore/LearnMore';
import MainProfileDetails from './MainProfileDetails/MainProfileDetails';
import ProfileImageHolder from './ProfileImageHolder/ProfileImageHolder';

const MainProfileLarge: FC<MainProfileProps> = ({ talentInfo, preferences, changeActiveLink, agencyActivated }) => {
  return (
    <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <Box style={{ display: 'flex', gap: '10px' }}>
        <ProfileImageHolder picture={talentInfo?.talent_picture} />
        <Box alignSelf={'end'}>
          <MainProfileDetails
            stage_name={talentInfo?.talent_stage_name}
            preferences={preferences}
            changeActiveLink={changeActiveLink}
            agencyActivated={agencyActivated}
          />
        </Box>
      </Box>
      <LearnMore />
    </Box>
  );
};
const MainProfileSmall: FC<MainProfileProps> = ({ talentInfo, preferences, changeActiveLink, agencyActivated }) => {
  return (
    <Fragment>
      <Box display={'flex'} justifyContent={'center'}>
        <ProfileImageHolder picture={talentInfo?.talent_picture} />
      </Box>
      <MainProfileDetails
        stage_name={talentInfo?.talent_stage_name}
        preferences={preferences}
        changeActiveLink={changeActiveLink}
        agencyActivated={agencyActivated}
      />
      <LearnMore />
    </Fragment>
  );
};

const MainProfile: FC<MainProfileProps> = ({ talentInfo, preferences, changeActiveLink, agencyActivated }) => {
  return (
    <MyLinksLayout>
      {/* Medium to Large View */}
      <Hidden smDown>
        <MainProfileLarge
          talentInfo={talentInfo}
          preferences={preferences}
          changeActiveLink={changeActiveLink}
          agencyActivated={agencyActivated}
        />
      </Hidden>

      {/* Small View */}
      <Hidden mdUp>
        <MainProfileSmall
          talentInfo={talentInfo}
          preferences={preferences}
          changeActiveLink={changeActiveLink}
          agencyActivated={agencyActivated}
        />
      </Hidden>
    </MyLinksLayout>
  );
};

export default MainProfile;
